<!-- <div class="content-wrapper container-xxl p-0"> -->
<div class="content-wrapper">
    <div class="content-body">
        <!-- content-header component -->
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <section id="sample-page">
            <div class="row">
                <div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-body pb-1">
                            <form #cadastroForm="ngForm">
                                <div class="card-body pb-1">

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label>Nome Tabela</label>
                                            <input [(ngModel)]="nome" #nomeRef="ngModel" class="form-ngModel" required
                                                type="text" name="nome" class="form-control"
                                                [class.error]="!nomeRef.valid && cadastroForm.submitted"
                                                placeholder="Nome Completo" />
                                            <span *ngIf="cadastroForm.submitted && nomeRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger" *ngIf="nomeRef.errors.required">
                                                    Campo Obrigatório!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label for="dateSelect">Data Início</label>
                                            <input type="date" [(ngModel)]="dt_inicio" #dateRef="ngModel" name="dt_inicio"
                                                class="form-control" id="dateSelect" required>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label for="dateSelect">Data Fim</label>
                                            <input type="date" [(ngModel)]=" dt_fim" #dateRef="ngModel" name="dt_fim"
                                                class="form-control" id="dateSelect" required>
                                        </div>
                                    </div>

                                    <hr class="my-50" />
                                    <br>
                                    <div class="card-body invoice-padding invoice-product-details" *ngIf="href.value[1].path != 'visualizar'"
                                        style="background-color: #fff;">
                                        <h3 style="font-size: 18px; font-weight: bold; margin-top: -35px;">
                                            <i data-feather="codepen" class="mr-25"></i>
                                            Quantidade & Valores
                                        </h3>
                                        <br><br>
                                        <div class="source-item">
                                            <div data-repeater-list="group-a">
                                                <div class="repeater-wrapper" data-repeater-item
                                                    *ngFor="let item of items; let i = index" @heightIn>
                                                    <div class="row" style="border-bottom: #6283a02c 1px solid;">

                                                        <div
                                                            class="col-12 d-flex product-details-border position-relative pr-0">
                                                            <div class="row w-100 pr-lg-0 pr-1 py-2">
                                                                <div class="col-lg-2 col-12 my-lg-0 my-2">
                                                                    <p class="card-text col-title mb-md-2 mb-0">
                                                                        Quantidade Inicio</p>
                                                                    <input type="number" class="form-control"
                                                                        id="itemQuantity{{ i }}"
                                                                        name="itemQuantity{{ i }}" min='0'
                                                                        [(ngModel)]="item.qtd_inicio" placeholder="0" />
                                                                </div>

                                                                <div class="col-lg-2 col-12 my-lg-0 my-2">
                                                                    <p class="card-text col-title mb-md-2 mb-0">
                                                                        Quantidade Fim</p>
                                                                    <input type="number" class="form-control"
                                                                        id="itemQuantity{{ i }}"
                                                                        name="itemQuantity{{ i }}" min='0'
                                                                        [(ngModel)]="item.qtd_fim" placeholder="0" />
                                                                </div>

                                                                <div class="col-lg-2 col-12 my-lg-0 my-2">
                                                                    <p class="card-text col-title mb-md-2 mb-0">Valor P/
                                                                        Ativo</p>
                                                                    <!-- <input prefix="R$ " type="text" mask="separator.2"
                                                                        [(ngModel)]="item.item_valor"
                                                                        class="form-control" placeholder="R$ 100" /> -->
                                                                    <input type="text" class="form-control"
                                                                        id="itemQuantity{{ i }}"
                                                                        name="itemQuantity{{ i }}" min='0'
                                                                        [(ngModel)]="item.item_valor" placeholder="0"
                                                                        prefix="R$ " mask="separator.2"
                                                                        thousandSeparator="." decimalMarker="," />
                                                                </div>

                                                            </div>
                                                            <div
                                                                class="d-flex flex-column align-items-center justify-content-between border-left invoice-product-actions py-50 px-25">
                                                                <button (click)="deleteItem(i)" class="btn p-0">
                                                                    <i data-feather="x" [size]="18"
                                                                        class="cursor-pointer"></i>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div *ngIf="items.length == 0">Não há itens adicionados na tabela</div>
                                            </div>
                                            <div class="row mt-1">
                                                <div class="col-12 px-0">
                                                    <button type="button"
                                                        class="btn btn-primary btn-sm btn-add-new ml-1"
                                                        (click)="addItem()" rippleEffect>
                                                        <i data-feather="plus" class="mr-25"></i>
                                                        <span class="align-middle">Adicionar Item</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="href.value[1].path == 'visualizar'">
                                        <table>
                                            <thead>
                                              <tr>
                                                <th>Quantidade Inicial</th>
                                                <th>Quantidade Final</th>
                                                <th>Valor do Item</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr *ngFor="let item of items">
                                                <td>{{ item.qtd_inicio }}</td>
                                                <td>{{ item.qtd_fim }}</td>
                                                <td>R$ {{ item.item_valor }}</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                    </div>

                                    <hr class="my-50" *ngIf="href.value[1].path != 'visualizar'" />
                                    <br>

                                    <div class="col-12 mt-50 " *ngIf="href.value[1].path != 'visualizar'">
                                        <button routerLink="/sistema/" class="btn btn-secondary botao-cancelar"
                                            rippleEffect>Cancelar</button>

                                        <button (click)="submitForm()" class="btn btn-primary btn-next " rippleEffect>
                                            <span class="align-middle d-sm-inline-block d-none">Salvar</span>
                                            <i data-feather="arrow-right"
                                                class="isHidden align-middle ml-sm-25 ml-0"></i>
                                            <span class="spinner-border-sm align-middle ml-sm-25 ml-0" role="status"
                                                aria-hidden="true"></span>
                                        </button>
                                        <br>
                                        <br>
                                        <div *ngIf="isLoading" class="spinner-border"></div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</div>